module.exports = __webpack_public_path__ + "media/images/Interior White Door and Trim-c23d40f2.jpg";